(function (appComponents) {

	appComponents.controllers.afterHours = function (Components) {
		var afterHours = {};

		afterHours.name = "afterHours";

		Components.getControllerPrototype().extend(afterHours);

		afterHours.bindings = function () {

			$(document).on("click", "[pc-click-and-go]", function () {
				var elementClick = $(this).data("href");
				var headerHeightAfrerPage = afterHours._elements.header.height();
				var destination = $(elementClick).offset().top - headerHeightAfrerPage;
				$('html, body').animate({
					scrollTop: destination
				}, 1100);
			});

		};

		afterHours.handlers = {

		};

		afterHours.init = function () {
			afterHours._renderPageTemplate();
			afterHours._bindings();
			afterHours._events.dispatchEvent("controllerInitialized");

		};

		return afterHours;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});